<template>
  <div class="register">
    <div class="registerbody container">
      <h2 class="secondary_title">{{ $t("login.create_account") }}</h2>
      <v-line></v-line>
      <form method="POST" action="/register" @submit="CheckRegister">
        <input type="hidden" name="_token" :value="token" />
        <div class="inputgroup">
          <ul class="row" style="padding-left: 0">
            <li
              class="col-md-6 col-12 offset-md-3 secondary_title"
              id="eamilerror"
              :errmes="error_email"
              v-if="error_email"
              v-html="error_email"
            >
            </li>
            <li
              class="col-md-6 col-12 offset-md-3 secondary_title"
              id="passworderror"
              :errmes="error_password"
              v-if="error_password"
            >
              {{ error_password }}
            </li>
            <li
              class="col-md-6 col-12 offset-md-3 secondary_title"
              id="nameerror"
              :errmes="error_first_name"
              v-if="error_first_name"
            >
              {{ error_first_name }}
            </li>
            <li
              class="col-md-6 col-12 offset-md-3 secondary_title"
              id="eamilerror"
              :errmes="error_last_name"
              v-if="error_last_name"
            >
              {{ error_last_name }}
            </li>
          </ul>
          <div class="row">
            <input
              id="name"
              type="text"
              :placeholder="$t('login.first_name')"
              class="col-md-6 col-12 offset-md-3"
              name="first_name"
              autocomplete="name"
              autofocus
            />
            <!-- <input type="text" placeholder="First Name" class="col-md-6 col-12 offset-md-3" v-model="firstname" /> -->
          </div>
          <div class="row">
            <input
              id="last_name"
              type="text"
              :placeholder="$t('login.last_name')"
              class="col-md-6 col-12 offset-md-3"
              name="last_name"
              autocomplete="name"
            />

            <!-- <input type="text" placeholder="Last Name" class="col-md-6 col-12 offset-md-3" v-model="lastname" @blur="regexname" /> -->
          </div>
          <div class="row">
            <input
              id="email"
              type="email"
              :placeholder="$t('login.email')"
              class="col-md-6 col-12 offset-md-3"
              name="email"
              required
              autocomplete="email"
            />
            <!-- <input type="email" placeholder="Email" class="col-md-6 col-12 offset-md-3" v-model="email" /> -->
          </div>
          <div class="row">
            <input
              id="password"
              type="password"
              :placeholder="$t('login.password')"
              class="col-md-6 col-12 offset-md-3"
              name="password"
              required
              autocomplete="new-password"
            />
            <!-- <input type="password" placeholder="Password" class="col-md-6 col-12 offset-md-3" v-model="password" /> -->
          </div>
          <!-- shopxy无确认密码字段，该表单必须提交一个确认密码 -->
          <div class="row" style="display: none">
            <input
              id="password-confirm"
              type="password"
              class="col-md-6 col-12 offset-md-3"
              placeholder="password-confirm"
              name="password_confirmation"
            />
            <!-- <input type="password" placeholder="Password" class="col-md-6 col-12 offset-md-3" v-model="password" /> -->
          </div>
          <div class="row">
            <button
              class="col-md-6 col-12 offset-md-3 main_button secondary_title"
              id="register"
            >
              {{ $t("login.create") }}
            </button>
          </div>
          <p>
            <a class="secondary_title" href="/">{{ $t("login.return_to_store") }}</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "error_last_name",
    "error_first_name",
    "error_password",
    "error_email",
  ],
  data() {
    return {
      token: document.head.querySelector('meta[name="csrf-token"]').content,
    };
  },
  methods: {
    CheckRegister(ev) {
      this.$("#register").attr("disabled", "true");
      this.$("#register").css("cursor", "wait");
      this.$("#register").css("background", "gray");
      this.$("body").css("cursor", "wait");
      let password = document.getElementById("password");
      let passwordSure = document.getElementById("password-confirm");
      let name = document.getElementById("name");
      let last_name = document.getElementById("last_name");
      let email = document.getElementById("email");
      passwordSure.value = password.value;
      window.sessionStorage.setItem("name", name.value);
      window.sessionStorage.setItem("last_name", last_name.value);
      window.sessionStorage.setItem("email", email.value);
      return true;
    },
  },
  mounted() {
    if (
      this.$("#eamilerror").attr("errmes") ||
      this.$("#passworderror").attr("errmes") ||
      this.$("#nameerror").attr("errmes")
    ) {
        console.log(this.$('#name'));
      this.$("#name")[0].value = window.sessionStorage.getItem("name");
      this.$("#last_name")[0].value = window.sessionStorage.getItem(
        "last_name"
      );
      this.$("#email")[0].value = window.sessionStorage.getItem("email");
    }
  },
};
</script>
<style scoped lang='scss'>
.register {
  .registerbody {
    padding-top: 80px;
    text-align: center;

    h2 {
      margin-top: 16px;
    }

    .inputgroup {
      margin-top: 50px;
      padding: 0 30px;
      ul {
          margin-bottom: 0;
        li {
          margin-bottom: 16;
        }
      }
      input,
      button {
        height: 44px;
        padding: 8px 10px;
        background: #f6f6f6;
        border: none;
        margin-bottom: 10px;
      }

      button {
        background: rgb(201, 13, 13);
        color: white;
      }
      button:hover {
        background: rgb(241, 34, 34);
      }
      button:active {
        background: rgb(86, 6, 6);
      }
      a {
        text-decoration: none;
        color: black;
        font-size: 12px;
      }

      ul {
        li {
          list-style-type: disc;
          list-style-position: inside;
          background-color: #fff6f6;
          border: 1px solid red;
          color: red;
          line-height: 28px;
          font-size: 12px;
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>